<!-- ATLAS-700 Reporting - Clawback: Cls & Nvr Liv Accts vs Appvl Dt - view file -->
<template>
  <div class="_report">
    <ReportFilter v-model="filter" :filterHook="filterHook" :config="filterConfig" />
    <ElasticList
      v-if="filter.isReady"
      :list="list"
      :rawFilter="filter.filter"
      ref="elasticListRef"
    />
  </div>
</template>

<script>
import _ from "lodash";
import ElasticList from "@/components/DynamicForm/ElasticList";
import ReportFilter from "@/pages/Reports/include/ReportFilter";
import ClawbackClsNvrLivActsApprvlDtConfig from "./include/configs/ClawbackClsNvrLivActsApprvlDtConfig";
import ReportConfigDefaults from "./include/configs/ReportConfigDefaults";

export default {
  components: {
    ElasticList,
    ReportFilter
  },
  data() {
    return {
      filter: {
        isReady: false,
        filter: null
      },
      list: ClawbackClsNvrLivActsApprvlDtConfig(this),
      services: [],
      filterConfig: {
        formatResponse : this.formatResponse,
        columns: ClawbackClsNvrLivActsApprvlDtConfig(this).columns,  
        csv: {
          reportName: 'ClawbackClsNvrLivActsApprvlDt',
          listQueryId: ClawbackClsNvrLivActsApprvlDtConfig(this).listQueryId,
          responseFieldName: ClawbackClsNvrLivActsApprvlDtConfig(this).responseFieldName
        }  
      },
    };
  },
  methods: {
    filterHook(services, queryParams, form) {
      this.services = services;
      const serviceIds = [];
      const idFilters = [];
      services.forEach(_service => serviceIds.push(_service.id));
      if (serviceIds.length) {
        serviceIds.forEach(_id => idFilters.push({ match_phrase: { id: _id } }));
      } else if (
        !idFilters.length &&
        (form.portfolio.length || form.dateFrom || form.dateTo || form.dateField)
      ) {
        idFilters.push({ match: { id: -1 } });
      }
      queryParams.must.push({ bool: { should: idFilters } });
    },
    formatResponse(data) {
      const services = this.$reduce(data, "searchServices.items");
      let items = [];
      if (services && services.length) {
        items = services.map((_service) => {
          // restore portfolio, account data
          const serviceIndex = this.services.findIndex(_loopService => _loopService.id == _service.id);
          if (-1 != serviceIndex) {
            _service.portfolio = _.cloneDeep(this.services[serviceIndex].portfolio);
            _service.account = _.cloneDeep(this.services[serviceIndex].account);
          }

          //prepare data row
          const row = {
            id: this.$reduce(_service, "id"),
            account: this.$reduce(_service, "account.name"),
            portfolio: this.$reduce(_service, "portfolio.name"),
            name: this.$reduce(_service, "name"), //service object name
            merchantNumber: this.$reduce(_service, "merchantNumber"),
            status: this.$reduce(_service, "status"),
            approvalDate: this.$reduce(_service, "approvalDate"),
            isRestructured: this.$reduce(_service, "isRestructured") ? true : false,
            closeDate: this.$reduce(_service, "closeDate"),
            dateFirstProcessing: this.$reduce(_service, "dateFirstProcessing"),
            closeReason: this.$reduce(_service, "closeReason"),
            closeReasonDetails: this.$reduce(_service, "closeReasonDetails")
          };

          // remove null values - set them to blank
          Object.keys(row).map(_key => {
            if (null === row[_key]) {
                row[_key] = '';
            }
          });
          
          return row;
        });
      }

      // sort results
      const elasticListRef = this.$refs.elasticListRef;
      items = _.sortBy(items, elasticListRef.currentSort);
      if ('desc' == elasticListRef.currentSortDir) {
          return items.reverse();
      }
      return items;
    }
  }
};
</script>